import $ from 'jquery';
$('.form-group--field-subject select').on('change', function () {
    if($(this).val() === 'sonstiges') {
        $(this).closest('form').find('.form-group--field-custom-subject').addClass('show')
    } else {
        $(this).closest('form').find('.form-group--field-custom-subject').removeClass('show')
        $(this).closest('form').find('.form-group--field-custom-subject input').val('')
    }
})

$('.form-upload__drag-drop').on('dragenter',function () {
    $(this).addClass('form-upload__drag-drop--hover');
})
$('.form-upload__drag-drop').on('dragleave',function () {
    $(this).removeClass('form-upload__drag-drop--hover');
})
$('.form-upload__drag-drop').on('drop',function () {
    $(this).removeClass('form-upload__drag-drop--hover');
})

$('.form-upload input').on('change', function () {
    var file = this.files[0];
    var $uploads = $(this).closest('.form-upload').find('.form-upload__uploads');
    var $info = $(this).closest('.form-upload').find('.form-upload__drag-drop-info');
    if (FileReader && file) {
        var filesize = Math.round(file.size / 1024);
        var fr = new FileReader();
        fr.onload = function () {

            var src = fr.result;
            if(src.match(/^data:application\/pdf/)) {
                src = '/typo3conf/ext/lfmsite/Resources/Public/Images/pdf-upload.svg'
            }
            $uploads.html('<div class="form-upload__upload">' +
                '<img src="'+ src +'" alt="' + file.name + '" title="' + file.name + '" class="img-fluid form-upload__upload-image"/>' +
                '<div class="form-upload__upload-title">' + file.name + ' (' + filesize +' KB)</div>' +
                '</div>')
        }
        fr.readAsDataURL(file);
        $info.addClass('form-upload__drag-drop-info--hide')
    }
})
